export default function Testimonials() {
  const testimonials = [
    {
      quote: 'I used to rush through my mornings feeling scattered. Now I start with an affirmation and a quick reflection. It takes 5 minutes but changes my entire day.',
      name: 'Sarah Chen',
      context: 'Marketing Director, Mother of Two'
    },
    {
      quote: 'The affirmations aren\'t cheesy or over-the-top. They feel real and grounded. I actually believe what I\'m saying to myself now.',
      name: 'Marcus Thompson',
      context: 'Entrepreneur & Coach'
    },
    {
      quote: 'I\'ve tried journaling apps before but never stuck with them. This system is simple, structured, and doesn\'t feel like homework. It just works.',
      name: 'Elena Rodriguez',
      context: 'Therapist & Wellness Advocate'
    }
  ];

  return (
    <section id="testimonials" className="bg-[#2C2C2C] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Title */}
        <h2 className="text-4xl lg:text-5xl font-bold text-white text-center mb-20">
          Real Impact, Real People
        </h2>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 ${
                index === 1 ? 'lg:-mt-10' : ''
              }`}
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <i className="ri-double-quotes-l text-5xl text-[#FFB8B8]"></i>
              </div>

              {/* Quote Text */}
              <p className="text-lg text-[#2C2C2C] leading-relaxed mb-8">
                {testimonial.quote}
              </p>

              {/* Divider */}
              <div className="w-10 h-0.5 bg-[#E5E5E5] mb-6"></div>

              {/* Author */}
              <div>
                <div className="text-base font-semibold text-[#2C2C2C] mb-1">
                  {testimonial.name}
                </div>
                <div className="text-sm text-[#8B8B8B] italic">
                  {testimonial.context}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
